/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-05-28 22:51:41
 * @LastEditTime: 2024-06-06 22:53:31
 * @LastEditors: yjf531 yjf531@126.com
 */
import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import { Http } from '@/utils/http.js'
import api from '@/config/api.js'

import { GetUrlRelativePath } from '@/utils/index.js'

//import store from '@/store'

import { getUrlKey } from '@/utils/index.js'

import Register from '@/components/Register'
import User from '@/components/User'
import ResearchList from '@/components/ResearchList'
import ResearchList2 from '@/components/ResearchList2'

import Question1 from '@/components/Question1'
import Question2 from '@/components/Question2'
import Question3 from '@/components/Question3'
import Question4 from '@/components/Question4'
import Question5 from '@/components/Question5'
import Question6 from '@/components/Question6'
import Question7 from '@/components/Question7'
import Question8 from '@/components/Question8'

import Index from '@/components/Index'  // 首页
import Index2 from '@/components/Index2'  // 首页
import Index3 from '@/components/Index3'  // 首页
import List from '@/components/List'   // 二级菜单列表页
import ListShow from '@/components/ListShow' // 二级菜单对应的列表
import ListShow2 from '@/components/ListShow2' // 薪酬视频对应的列表
import ListShow3 from '@/components/ListShow3' // 公立医院综合改革的列表
import Show from '@/components/Show' // 视频详情
import Show2 from '@/components/Show2' // 薪酬视频详情
import Show3 from '@/components/Show3' // 公立医院综合改革视频详情


import QuestionList from '@/components/QuestionList' // 答题列表
import Result1 from '@/components/Result1' // 评测结果1
import Result2 from '@/components/Result2' // 评测结果2
import Result3 from '@/components/Result3' // 评测结果3
import Clear from '@/components/Clear' // 清缓存
import Middle from '@/components/Middle' // 中间过度页为了写cookie 及时生效

import Apply from '@/components/Apply' // 个人信息修改
import Hospital from '@/components/Hospital' // 医院介绍
import Statement from '@/components/Statement' // 答题介绍

import Show4 from '@/components/Show4' // 公立医院综合改革视频详情
import Show5 from '@/components/Show5' // 公立医院综合改革视频详情
import Show6 from '@/components/Show6' // 公立医院综合改革视频详情

import Baoming from '@/components/Baoming' // 会议报名
import BaomingSuccess from '@/components/BaomingSuccess' // 会议报名成功

import Baoming2 from '@/components/Baoming21' // 会议报名2
import BaomingSuccess2 from '@/components/BaomingSuccess21' // 会议报名成功

import Baoming3 from '@/components/Baoming3' // 会议报名2
import H5toWeapp from '@/components/H5toWeapp' // 


import BaomingClose from '@/components/BaomingClose' // 会议关闭1
import BaomingClose2 from '@/components/BaomingClose2' // 会议关闭2

import Research from '@/components/Research' // 调研
import ResearchPart2 from '@/components/ResearchPart2' // 调研第二部分
import ResearchPart3 from '@/components/ResearchPart3' // 调研第三部分

import ResearchNoWeChat from '@/components/ResearchNoWeChat' // 调研不在微信
import ResearchNoWeChatPart2 from '@/components/ResearchNoWeChatPart2' // 调研第二部分
import ResearchNoWeChatPart3 from '@/components/ResearchNoWeChatPart3' // 调研第三部分

import test2 from '@/components/test2' // 调研第三部分

Vue.use(Router)

//47.104.220.28
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index2
    },
    {
      path: '/Index2',
      name: 'Index2',
      component: Index2
    },
    {
      path: '/Index3',
      name: 'Index3',
      component: Index
    },
    {
      path: '/List',
      name: 'List',
      component: List
    },
    {
      path: '/ListShow',
      name: 'ListShow',
      component: ListShow
    },
    {
      path: '/ListShow2',
      name: 'ListShow2',
      component: ListShow2
    },
    {
      path: '/ListShow3',
      name: 'ListShow3',
      component: ListShow3
    },
    {
      path: '/Show',
      name: 'Show',
      component: Show4
    },
    {
      path: '/Show3',
      name: 'Show3',
      component: Show6
    },
    {
      path: '/Show2',
      name: 'Show2',
      component: Show5
    },
    {
      path: '/Show4',
      name: 'Show4',
      component: Show4
    },
    {
      path: '/Show5',
      name: 'Show5',
      component: Show5
    },
    {
      path: '/Show6',
      name: 'Show6',
      component: Show6
    },
    {
      path: '/Question1',
      name: 'Question1',
      component: Question1
    },
    {
      path: '/Question2',
      name: 'Question2',
      component: Question2
    },
    {
      path: '/Question3',
      name: 'Question3',
      component: Question3
    },
    {
      path: '/QuestionList',
      name: 'QuestionList',
      component: QuestionList
    },
    {
      path: '/Result1',
      name: 'Result1',
      component: Result1
    },
    {
      path: '/Result2',
      name: 'Result2',
      component: Result2
    },
    {
      path: '/Result3',
      name: 'Result3',
      component: Result3
    },
    {
      path: '/Clear',
      name: 'Clear',
      component: Clear
    },
    {
      path: '/Middle',
      name: 'Middle',
      component: Middle
    },
    {
      path: '/Apply',
      name: 'Apply',
      component: Apply
    },
    {
      path: '/Hospital',
      name: 'Hospital',
      component: Hospital
    },
    {
      path: '/Statement',
      name: 'Statement',
      component: Statement
    },
    {
      path: '/BaomingClose',
      name: 'BaomingClose',
      component: BaomingClose
    },
    {
      path: '/BaomingClose2',
      name: 'BaomingClose2',
      component: BaomingClose2
    },
    {
      path: '/BaomingSuccess',
      name: 'BaomingSuccess',
      component: BaomingSuccess
    },
    {
      path: '/test2',
      name: 'test2',
      component: test2
    },
    {
      path: '/Baoming',
      name: 'Baoming',
      component: Baoming
    },
    {
      path: '/Baoming2',
      name: 'Baoming2',
      component: Baoming2
    },
    {
      path: '/Baoming3',
      name: 'Baoming3',
      component: Baoming3
    },
    {
      path: '/H5toWeapp',
      name: 'H5toWeapp',
      component: H5toWeapp
    },
    {
      path: '/BaomingSuccess2',
      name: 'BaomingSuccess2',
      component: BaomingSuccess2
    },
    {
      path: '/Research',
      name: 'Research',
      component: Research
    },
    {
      path: '/ResearchPart2',
      name: 'ResearchPart2',
      component: ResearchPart2
    },
    {
      path: '/ResearchPart3',
      name: 'ResearchPart3',
      component: ResearchPart3
    },
    {
      path: '/ResearchNoWeChat',
      name: 'ResearchNoWeChat',
      component: ResearchNoWeChat
    },
    {
      path: '/ResearchNoWeChatPart2',
      name: 'ResearchNoWeChatPart2',
      component: ResearchNoWeChatPart2
    },
    {
      path: '/ResearchNoWeChatPart3',
      name: 'ResearchNoWeChatPart3',
      component: ResearchNoWeChatPart3
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  //  Cookies.set('uid', 1, { expires: 1 })
  //  Cookies.set('openid', 'olBcGt5zOfBRJFYjBr19FNfXekgc', { expires: 1 })
  // 获取登录过的openid
   const openid = Cookies.get('openid')
   const uid = Cookies.get('uid')
   const openid2 = Cookies.get('openid2')
   const uid2 = Cookies.get('uid2')
   const openid3 = Cookies.get('openid3')
   const uid3 = Cookies.get('uid3')
  //  next()
  //  return 
  // 清除缓存
  if (to.name !== 'Clear'){
    next()
  }

  if (to.name == 'ResearchNoWeChat' || to.name == 'ResearchNoWeChatPart2' || to.name == 'ResearchNoWeChatPart3'){
    next()
    return 
  }
 
  if (uid3 || openid3) {
//     if (to.name !== 'Register') {
//       let data = {};
//       data.openid = Cookies.get('openid');
//       Http.post(api.getUserInfo, data).then((response) => {
//         if(response.code == 1){
//           console.log(response)
//           if(response.data.id != 0){
//             Cookies.set('uid',response.data.id,{expires: 1})
//           }
//           next() // 跳转
//         }else{
//           // 未在后台用户中心且要跳转的页面不是登录页
//           next({
//             name: 'Register' // 跳转到登录页
//           })
//           return false
//         }
//       })
//     } else {
//       // 未登陆且要跳转的页面是登录页
//       next() // 跳转
//     }
    // 未登陆且要跳转的页面是登录页 
    next() // 跳转
  } else {
    const code = getUrlKey('code') // 截取url上的code ,可能没有,则返回''空字符串
    let data = {}
    data.code = code
    if (!code) {
      let redirectUrl = GetUrlRelativePath()
     // redirectUrl = encodeURIComponent(redirectUrl)

     //let redirectUrl2 = window.location.href
           //redirectUrl = 'http://api.ym.local/user'
      const appid = 'wx332c7b17d6d5caba' // 正式
      //const appid = 'wx072f2cc6988a2944'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    }
    let res = await Http.get(api.getWechatOpenid, data) // 获取用户信息,后端可首先通过cookie,session等判断,没有信息则通过code获取
    // 返回用户信息
    const backdata = res.data
    if (backdata.code === 1 && backdata.data.openid) {
      // 设置cookie 值
      Cookies.set('openid', backdata.data.openid, { expires: 240 })
      Cookies.set('openid2', backdata.data.openid, { expires: 240 })
      Cookies.set('openid3', backdata.data.openid, { expires: 240 })
      Cookies.set('province', backdata.data.province, { expires: 240 })
      Cookies.set('city', backdata.data.city, { expires: 240 })
      Cookies.set('nickname', backdata.data.nickname, { expires: 240 })
      Cookies.set('sex', backdata.data.sex, { expires: 240 })
      // store.dispatch('setOpenid',{openid: backdata.data.openid})
      // store.dispatch('setProvince',{province: backdata.data.province})
      // store.dispatch('setCity',{city: backdata.data.city})
      // store.dispatch('setNickname',{nickname: backdata.data.nickname})
      // store.dispatch('setSex',{sex: backdata.data.sex})
      if (backdata.uid) {
        Cookies.set('uid', backdata.uid, { expires: 240 })
        Cookies.set('uid2', backdata.uid, { expires: 240 })
        Cookies.set('uid3', backdata.uid, { expires: 240 })
        //store.dispatch('setUserid',{uid: backdata.uid })
      }
      //this.$router.push({ name: "Middle" });
      // 跳到中转页
      //window.location.href = 'http://xkxytest.local/Middle'
      //正式环境
     // window.location.href = 'http://st.medmeet.com.cn/Middle'
      // console.log('书记---222888')
      // console.log(backdata)
      
      // console.log('书记---7777')
      window.location.reload(true)
      //next()
    } else {
      // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
      let redirectUrl = GetUrlRelativePath()
      // console.log('test--11')
      // console.log(redirectUrl)
      // console.log(window.location.href)
      // console.log('test--22')

      // return
      redirectUrl = encodeURIComponent(redirectUrl)
      //redirectUrl = 'http://api.ym.local/user'
      const appid = 'wx332c7b17d6d5caba' //正式
      //const appid = 'wx072f2cc6988a2944' // 测试
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    }
 }
})

// router.afterEach(function (transition) {
 
// });
export default router



// WEBPACK FOOTER //
// ./src/router/index.js